/**
 * Created by fers on 12.03.16.
 */

import VariableResolverParser from './VariableResolverParser'; // eslint-disable-line import/named

/**
 * Function that replace all occurances of variables in string str.
 * String is in format "something {variable} something else" or "something ${expression} something else".
 *
 * It replaces only variables present in "options"
 *
 * @param str
 * @param options
 * @returns {string}
 */
export function variableResolver(str: string, options: Object, keepMissingVariables: boolean = false): string {
    if (!str) {
        return '';
    }

    return VariableResolverParser.parse(str, {
        variables: options,
        keepMissingVariables: keepMissingVariables
    });
}

export function resolverGetUsedVariables(str : string) {
    if (!str) {
        return {};
    }

    return VariableResolverParser.parse(str, {
        variables: {},
        returnUsedVariables: true
    });
}

export function safeVariableResolver(str: string, options: Object, keepMissingVariables: boolean = false): string {
    try {
        return variableResolver(str, options, keepMissingVariables);
    } catch (e) {
        return " Error: " + e.message;
    }
}
